function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import cn from 'classnames';
import { formatDistance, differenceInMilliseconds } from 'date-fns';
import T from 'prop-types';
import React, { useCallback } from 'react';
import { Badge } from 'react-bootstrap';
import text from '../../text';
import { statuses, statusLight } from './consts';
var calculateETA = function(leftTime, rightTime) {
    var eta = differenceInMilliseconds(leftTime, rightTime);
    if (eta > 0) {
        return formatDistance(leftTime, rightTime);
    } else {
        return text('numberOfDays', {
            daysNumber: 0
        });
    }
};
var Status = function(param) {
    var className = param.className, job = param.job;
    var getStatus = useCallback(function() {
        if (!job.status) {
            return;
        }
        if ([
            'pending',
            'inprogress'
        ].includes(job.status) && job.expected_at) {
            return statuses[job.status].name + '\n' + text('expectedAt', {
                eta: calculateETA(new Date(job.expected_at), new Date())
            });
        }
        return statuses[job.status].name;
    }, [
        job
    ]);
    return /*#__PURE__*/ React.createElement("span", {
        className: cn('tblstatus', _define_property({}, className, className))
    }, job.status === 'demo' ? /*#__PURE__*/ React.createElement(Badge, {
        variant: "info"
    }, "SAMPLE") : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("span", {
        className: "status-circle ".concat(statusLight[job.status])
    }), /*#__PURE__*/ React.createElement("span", null, getStatus(), /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement("span", {
        className: "very-small"
    }, /*#__PURE__*/ React.createElement("span", null, job.completed_date ? new Date(job.completed_date).getDate() + '/' + (new Date(job.completed_date).getMonth() + 1) + '/' + new Date(job.completed_date).getFullYear() : '')))));
};
Status.propTypes = {
    job: T.shape(),
    className: T.string
};
export default Status;
